import * as React from 'react';
import BtnEditAct from "../../simple/Buttons/BtnEditAct/BtnEditAct";

export const buttonText = "Section Header Btn";

export const SectionHeaderDefProps = {
  sectionHeaderTitle: 'Section Header Title',
  sectionHeaderBtn: <BtnEditAct onClick={null}>{buttonText}</BtnEditAct>
};